import { Avatar, Grid, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import { ScannerConnectionStatusWrapper } from './account-connection-wrapper.component'
import { AccountConnectionIndicator } from 'src/components/step-accounts-connection/association/account-connection-indicator.component'

import useStyles from 'src/components/associations/styles'
import { useStyles as useStyles1 } from './styles'

interface IProps {
  icon: string
  text: string
  subText?: string
  handleSelectItem?: (value: string) => void
  id: string
  approvedConnection: boolean
}

const ConnectionListItem = ({
  icon,
  subText,
  text,
  handleSelectItem,
  id,
  approvedConnection,
}: IProps) => {
  const classes = useStyles({})
  const classes1 = useStyles1()

  const handleItemRemove = () => {
    handleSelectItem?.(id)
  }

  return (
    <>
      <div className={classes1.selectionWrapper}>
        <Grid className={classes1.selectionContent}>
          <Grid className={classes.selectionItem}>
            <Avatar alt={text} src={icon} className={`${classes.image}`} />
            <Grid>
              <Typography className={`${classes.selectionText} ${classes.selectionTextDark}`}>
                <strong>{text}</strong>
              </Typography>
              <Typography className={`${classes.selectionSubtext} ${classes.selectionTextDark}`}>
                {subText}
              </Typography>
            </Grid>
          </Grid>
          <div className={classes1.statusWrapper}>
            <ScannerConnectionStatusWrapper approvedConnection={approvedConnection}>
              <AccountConnectionIndicator approvedConnection={approvedConnection} />
            </ScannerConnectionStatusWrapper>
            <IconButton onClick={handleItemRemove} size="small">
              <CloseIcon />
            </IconButton>
          </div>
        </Grid>
      </div>
    </>
  )
}

export { ConnectionListItem }
